import { routeInfo } from '../../../routeInfo';
import * as React from 'react';
import { Link } from 'react-router';
import { IProject } from '../../../models/IProject';
import Overlay from '../../components/Overlay/Overlay';
import ConfirmPopup from '../../../views/components/ConfirmPopup/ConfirmPopup';
import HistoryKeeper from '../../../services/HistoryKeeper';
import HeaderPartSeparator from '../HeaderPartSeparator/HeaderPartSeparator';
import device from '../../../services/mini/device';
import projectHelper from '../../../services/ProjectHelper';
import { saveAllClick } from '../../../views/pages/project/ScriptsPanel/scriptPanelUIHelper';

type HeaderNavigationProps = {
    project?: IProject
    projectName?: string,
    logoOnly?: boolean,
    hideBackButton?: boolean,
    className?: string,
    cutAfter?: number,
    onBack?: () => void,
}

const HeaderNavigation = React.memo(function HeaderNavigation({ project, projectName, logoOnly, hideBackButton, className, cutAfter, onBack }: HeaderNavigationProps) {
    const [isCloseWarningShown, setIsCloseWarningShown] = React.useState(false);
    const prevLocation = HistoryKeeper.getPrevLocation();
    const hasBackPart = (prevLocation && prevLocation.title) || projectName;
    const showOnlyLogo = logoOnly || hasBackPart;

    const handleBack = async () => {
        if (onBack) {
            onBack();
            return;
        }
        const hasUnsavedChanges = await projectHelper.hasUnsavedChanges(project);
        if (project && hasUnsavedChanges) {
            setIsCloseWarningShown(true);
        } else {
            onClose();
        }
    };

    const onCancel = () => {
        setIsCloseWarningShown(false);
    };

    const onSaveAndClose = () => {
        onCancel();
        saveAllClick();
        HistoryKeeper.goBack(project);
    };

    const onClose = () => {
        onCancel();
        HistoryKeeper.goBack(project);
    };

    return <div className={`header-navigation ${className}`}>
        <Link to={routeInfo.projects.url()} className={`header-navigation_logo-link ${showOnlyLogo && 'logo-only'}`}>
            <span className="header-navigation_logo">
                <span className="header-navigation_logo_text tablet-and-bigger">Alan AI Studio</span>
            </span>
        </Link>
        {hideBackButton !== true &&
            <React.Fragment>
                <HeaderPartSeparator height={32} classes="before-back" />
                <a className={`header-navigation_back-holder ${!hasBackPart && 'only-arrow'}`}>
                    <span
                        onClick={handleBack}
                        className="action-btn light-blue-with-border main-header-btn header-navigation_back-to-projects-btn">
                        <i className="icon icon-alan-chevron-fat" />
                    </span>
                </a>
                <a className={`header-navigation_back-holder-fake ${!hasBackPart && 'only-arrow'}`}>
                    <span
                        className="action-btn light-blue-with-border main-header-btn header-navigation_back-to-projects-btn">
                        <i className="icon icon-alan-chevron-fat" />
                    </span>
                </a>
                {hasBackPart &&
                    <span title={projectName} className={`header-navigation_title ${!device.isDesktop() && 'mobile'}`}>
                        {projectName ? projectName.length > (cutAfter | 20) ? `${projectName.substring(0, (cutAfter | 20))}...` : projectName : prevLocation.title}
                    </span>}
                {isCloseWarningShown &&
                    <Overlay>
                        <ConfirmPopup
                            onClose={onCancel}
                            hideCancelBtn={true}
                            midBtnCbClass="light-red-with-border"
                            midBtnLabel="Don't save"
                            midBtnCb={() => {
                                onClose();
                            }}
                            okBtnLabel="Save changes"
                            okBtnCb={() => {
                                onSaveAndClose();
                            }}
                            title="Unsaved changes"
                            message={<div>There are unsaved changes in the «{projectName}» project. Do you want to save your changes?</div>}
                        />
                    </Overlay>
                }

            </React.Fragment>
        }
    </div>;
});
export default HeaderNavigation;
